module.exports = __webpack_public_path__ + "static/media/logo_volantinointerattivo_free.dc6c1d21.svg";